module.exports = __webpack_public_path__ + "media/images/singh-496c7fee8a1e649f5054b97cad8da6cc.jpg";